import { Injectable, inject } from '@angular/core';

import { SharedFeaturesApiService, UserService } from '@frontend/vanilla/core';

import { GeoCoordinatorClientConfig } from './client-config';

@Injectable({
    providedIn: 'root',
})
export class LocationInfoStatusService {
    private readonly user = inject(UserService);
    private readonly apiService = inject(SharedFeaturesApiService);
    private readonly geolocationConfig = inject(GeoCoordinatorClientConfig);

    fetchLocationInfoStatusFromGDS(): void {
        if (this.geolocationConfig.locationInfoStatus.fetchUrl) {
            this.apiService.post(`${this.geolocationConfig.locationInfoStatus.fetchUrl}ssoKey=${this.user.ssoToken}`).subscribe();
        }
    }
}
